import Finances from './components/Finances/Finances';
import { PriceGuideContainer } from './components/PriceGuideContainer/PriceGuideContainer';

export const PriceGuide = () => (
  <PriceGuideContainer>
    <Finances />
  </PriceGuideContainer>
);
